import { useState } from 'react';
import moment from 'moment';
import { useFormData } from '../../../../utils/formReducer';
import { FORM_ACTIONS } from '../../../../utils/formActions';

const MIN_AGE = 18;
const DATE_FORMAT = 'MM/DD/YYYY';
const MAX_DIGITS = 8;

export const useBirthdayInput = () => {
  const { dispatch } = useFormData();
  const [birthdayError, setBirthdayError] = useState<string>('');

  const validateBirthday = (value: string): boolean => {
    if (!value) {
      setBirthdayError('');
      return true;
    }

    const parsedDate = moment(value, DATE_FORMAT, true);
    if (!parsedDate.isValid()) {
      setBirthdayError('Please enter a valid date');
      return false;
    }

    if (moment().diff(parsedDate, 'years') < MIN_AGE) {
      setBirthdayError(`You must be at least ${MIN_AGE} years old`);
      return false;
    }

    setBirthdayError('');
    return true;
  };

  const formatDateInput = (digitsOnly: string): string => {
    let formattedValue = '';
    if (digitsOnly.length >= 1) {
      formattedValue = digitsOnly.substring(0, 2);
    }
    if (digitsOnly.length >= 3) {
      formattedValue += '/' + digitsOnly.substring(2, 4);
    }
    if (digitsOnly.length >= 5) {
      formattedValue += '/' + digitsOnly.substring(4, 8);
    }
    return formattedValue;
  };

  const handleBirthdayChange = (value: string) => {
    const digitsOnly = value.replace(/\D/g, '');

    if (digitsOnly.length > MAX_DIGITS) {
      return;
    }

    const formattedValue = formatDateInput(digitsOnly);

    dispatch({
      type: FORM_ACTIONS.UPDATE_FORM_FIELD,
      fieldName: 'birthday',
      payload: formattedValue,
    });

    validateBirthday(formattedValue);

    return formattedValue;
  };

  return {
    birthdayError,
    validateBirthday,
    handleBirthdayChange,
  };
};
